import { FC, useMemo } from "react";
import { Center, Text } from "@chakra-ui/react";

import { formatPriceWithoutZeros, isStringWithNumber } from "../../../../../utils";
import { ICheckActiveSbpTransferResponse } from "../../../../../api/sbpTransfer/types.ts";

interface Props {
  isLimitError: boolean;
  isTermsError: boolean;
  activeTransfer: ICheckActiveSbpTransferResponse | undefined;
}

export const SbpTransferPageContentMessage: FC<Props> = ({ isLimitError, isTermsError, activeTransfer }) => {
  const message = useMemo(() => {
    let result = "Не удалось загрузить данные";

    if (isLimitError) {
      result = "Не удалось загрузить информацию о доступном лимите";
    }

    if (isTermsError) {
      result = "Не удалось загрузить информацию о доступных сроках погашения";
    }

    if (activeTransfer?.isTrancheActive) {
      const rawAmount = activeTransfer.amount;
      const formattedAmount = isStringWithNumber(rawAmount) ? formatPriceWithoutZeros(Number(rawAmount)) : "";

      result = formattedAmount ? `Операция на сумму ${formattedAmount} в обработке` : "Операция в обработке";
    }

    return result;
  }, [isLimitError, isTermsError, activeTransfer]);

  return (
    <Center flex="1" pb="100px">
      <Text variant="brand" textAlign="center" maxW={isLimitError || isTermsError ? "265px" : "unset"}>
        {message}
      </Text>
    </Center>
  );
};
